export default __webpack_public_path__ + "static/media/info-white.32911e40.svg";